import { SdControllerUtilities } from "./sd-controller-utilities";
import app from "../../sdAppModule";
app.service("sdControllerUtilities", SdControllerUtilities);
